import Nullstack from 'nullstack';
export default function IconCeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ce-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 4a7.99 7.99 0 0 0 -2.581 .426"
  }), "   ", Nullstack.element("path", {
    d: "M5.867 5.864a8 8 0 0 0 5.133 14.136"
  }), "   ", Nullstack.element("path", {
    d: "M20 4a8.001 8.001 0 0 0 -7.29 4.7"
  }), "   ", Nullstack.element("path", {
    d: "M12 12a8 8 0 0 0 8 8"
  }), "   ", Nullstack.element("path", {
    d: "M16 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}